import { render, staticRenderFns } from "./PriceListBrowseWrapper.vue?vue&type=template&id=c146f760&scoped=true"
import script from "./PriceListBrowseWrapper.vue?vue&type=script&lang=ts"
export * from "./PriceListBrowseWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c146f760",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c146f760')) {
      api.createRecord('c146f760', component.options)
    } else {
      api.reload('c146f760', component.options)
    }
    module.hot.accept("./PriceListBrowseWrapper.vue?vue&type=template&id=c146f760&scoped=true", function () {
      api.rerender('c146f760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/price-lists/PriceListBrowseWrapper.vue"
export default component.exports